document.querySelectorAll('.template-product [data-add-btn]').forEach(btn => {
  btn.addEventListener('click', (e) => {
    e.preventDefault();

    const target = document.querySelector('.product__info-wrapper .product-form__submit');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });

      setTimeout(() => target.click(), 500);
    }
  });
});
